import React, { useContext, memo } from 'react';
import { AppContext } from 'Store/AppContext';
import { getWorkoutPage } from 'Domain/Service/VideoService';
import { VideoPlayer } from 'Components/Video/VideoPlayer';

import './VideoBodyWeb.scss';

export const VideoBodyWeb = () => {
  const context = useContext(AppContext);
  const page = getWorkoutPage(context.state);
  const currentVideo = context.state.currentVideo;
  let exercises = [];

  const addEmptySpace = (array, length) => {
    let mod = length % 3;
    if(length <= 3 || mod === 0) return 0;
    const emptySpaces = 3 - mod;
    for(let i=0; i < emptySpaces; i++) {
      array.push(<div className="video-body-item" />);
    }
  }

  if (page && page.isPlayingAll) {
    if (page.isPlayingAll) {
      exercises = page.exercises;
    } else {
      exercises = [page.exercises[currentVideo]];
    }
  } else {
    exercises = page.exercises;
  }

  let videos = [];
  for(let index = 0; index < exercises.length; index++) {
    const exercise = exercises[index];

    let itemNumberClass = 'video-body-item';
    if (exercises.length === 1) {
      itemNumberClass = 'video-body-item-1';
    } else if(exercises.length === 2) {
      itemNumberClass = 'video-body-item-2';
    }

    let play = context.state.isPlayingVideos;
    let overlayDark = null;

    if(!page.isPlayingAll) {
      play = index === currentVideo ? context.state.isPlayingVideos : false;
      overlayDark = index === currentVideo ? null : <OverlayDark />;
    }

    videos.push(
      <div className={itemNumberClass} key={'v_'+index}>
        <div className="video-body-container">
          <VideoPlayer url={exercise.url} isPlaying={play} />
          <Parameters amount={exercise.amount} unit={exercise.unit} />
          { overlayDark }
          <OverlayTitle name={exercise.name} />
        </div>
      </div>
    );

  }
  
  addEmptySpace(videos, exercises.length);
    
  return <div className="video-body-flex">{videos}</div>;
};

const Parameters = memo(({ amount, unit }) => {
  return (
    <>
      <div className="video-body-params-container">
        <div className="video-body-params">
          <div className="video-body-params-amount">{amount}</div>
          <div className="video-body-params-unit">{unit}</div>
        </div>
      </div>
    </>
  );
});

const OverlayDark = () => {
  return (
    <div className="video-body-overlay-opacity">
    </div>
  );
};

const OverlayTitle = memo(({ name }) => {
  return (
    <div className="video-body-overlay">
      <div className="video-body-gradient">
        <div className="video-body-title">{name}</div>
      </div>
    </div>
  );
});
